export default __webpack_public_path__ + "static/media/cap2.d195bf28.png";